import React from 'react'

export const AuthModal = ({ message }: { message: string }) => {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid rgb(244, 244, 244)',
          marginBottom: '15px',
          backgroundColor: 'rgb(249, 250, 251)',
          padding: '30px 40px',
          borderRadius: '10px',
          fontSize: '16px',
          textIndent: '10px',
          maxWidth: '80%',
          textAlign: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          pointerEvents: 'auto',
        }}
      >
        {message}
      </div>
    </div>
  )
}
